<template>
  <div class="hw-grid">
    <HrWorkforcePanel
      v-for="list in visibleRankedLists"
      :key="list.title"
      :title="list.title"
      :note="recordedCount(list.items) + ' of ' + current.total + ' recorded'"
    >
      <div class="hw-rank-list">
        <HrWorkforceBarRow
          v-for="item in list.items"
          :key="item.key"
          :name="item.label"
          :title="item.label"
          :segments="[item]"
          :scale="listMax(list.items)"
          :value="onlyCommaFormat(item.value)"
          :pill="percentLabel(item.value, current.total)"
          :pill-style="pctStyle(item)"
          name-width="minmax(0, 1.2fr)"
        />
      </div>
    </HrWorkforcePanel>
  </div>
</template>

<script setup>
import { toRef } from 'vue'
import figureFormatter from '@/services/utils/figureFormatter'
import { listMax, pctStyle, percentLabel, recordedCount, useHrWorkforceItems } from '@/components/molecule/company/dashboard/dynamic-dashboard/hr-workforce/common/hrWorkforce'
import HrWorkforcePanel from '@/components/molecule/company/dashboard/dynamic-dashboard/hr-workforce/common/HrWorkforcePanel.vue'
import HrWorkforceBarRow from '@/components/molecule/company/dashboard/dynamic-dashboard/hr-workforce/common/HrWorkforceBarRow.vue'

const props = defineProps({
  current: { type: Object, required: true },
  labels: { type: Object, required: true }
})

const { onlyCommaFormat } = figureFormatter()
const { visibleRankedLists } = useHrWorkforceItems(toRef(props, 'current'), toRef(props, 'labels'))
</script>

<style scoped src="./common/hrWorkforce.css"></style>

<style scoped>
.hw-rank-list {
  max-height: 280px;
  overflow-y: auto;
  scrollbar-width: thin;
}
</style>
